import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { developerApi } from '../../api/developer.api';
import type { ProviderResponseDto } from '../../types';

export function useDeveloperProvider() {
  return useQuery<ProviderResponseDto>({
    queryKey: ['developer', 'provider'],
    queryFn: async () => {
      const { data } = await developerApi.get('/v1/miniapp/provider');
      return data.data || data;
    },
    staleTime: 60_000,
  });
}

export function useUpdateDeveloperProvider() {
  const queryClient = useQueryClient();
  return useMutation<ProviderResponseDto, Error, { name?: string; description?: string }>({
    mutationFn: async (payload) => {
      const { data } = await developerApi.patch('/v1/miniapp/provider', payload);
      return data.data || data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['developer', 'provider'] });
    },
  });
}
